/**
 * COMMERCE-LAUNCH-168A-R2 — NovaPay live-create readiness for Customer UI.
 * Bake-time gate: production stays NOT live until VITE_NOVAPAY_LIVE_CREATE_V1=true
 * after owner GO + secrets + flags. Never invents success for a missing payment URL.
 */
import { isNovapayCheckoutDegradedStaging, isNovapayMethodSelectable } from "./novapay-staging-degraded-v2.js";

/** Typed Worker/UI state when production create is gated off. */
export const NOVAPAY_NOT_LIVE = "NOVAPAY_NOT_LIVE" as const;

export function isNovapayLiveCreateEnabled(): boolean {
  return String(import.meta.env.VITE_NOVAPAY_LIVE_CREATE_V1 ?? "")
    .trim()
    .toLowerCase() === "true";
}

/**
 * True when UI must not offer working NovaPay pay/send CTAs.
 * Staging degraded OR production pre-live (live-create bake flag off).
 */
export function isNovapayNotLiveUi(): boolean {
  if (isNovapayCheckoutDegradedStaging()) return true;
  if (!isNovapayLiveCreateEnabled()) return true;
  return false;
}

/** NovaPay method may appear as an option (info / soon), but not as a working pay CTA. */
export function isNovapayOptionVisible(): boolean {
  return isNovapayMethodSelectable() || !isNovapayLiveCreateEnabled();
}

export function isNovapayNotLiveError(error: string | null | undefined): boolean {
  const e = String(error ?? "").trim();
  return (
    e === NOVAPAY_NOT_LIVE ||
    e === "novapay_not_live" ||
    e === "production_forbidden" ||
    e === "novapay_checkout_disabled"
  );
}
